/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';

export class pharmacyindex extends IceEntity {
  pharmacy_index_key: string = "";
  pharmacy_type: string = "";
  trans_account: string = "";
  organization_name: string = "";
  street1: string = "";
  street2: string = "";
  city: string = "";
  state_id: string = "";
  postal_code: string = "";
  phone_num: string = "";
  identification_code1: string = "";
  identification_code2: string = "";
  identification_code3: string = "";
  identification_code4: string = "";
  identification_code5: string = "";
  identification_code6: string = "";
  identification_code7: string = "";
  identification_code8: string = "";
  identification_code9: string = "";
  service_type_code1: string = "";
  service_type_code2: string = "";
  service_type_code3: string = "";
  service_type_code4: string = "";
  service_type_code5: string = "";
  service_type_code6: string = "";
  service_type_code7: string = "";
  service_type_code8: string = "";
  service_type_code9: string = "";
  additional_name: string = "";
  active_start_time: string = "";
  active_end_time: string = "";

  constructor() {
    super();
  }

  gettablename(): string {
    return "PHARMACY_INDEX";
  }

  getdisplayname(organization: boolean): string {
    return this.organization_name;
  }
}

